import { useState } from 'react'
import { TabPanel, TabView, TabViewTabChangeParams } from 'primereact/tabview'
import { useTranslation } from 'react-i18next'

// local imports
import NotRatedReservationList from './NotRatedResList'

export default function SurveyAndEvaluations() {
  const { t } = useTranslation()
  const [activeIndex, setActiveIndex] = useState(0)
  const handleTabChange = (e: TabViewTabChangeParams) => setActiveIndex(e.index)

  return (
    <div className="mt-4 container">
      <TabView
        className="on-campus-service-tab"
        renderActiveOnly
        activeIndex={activeIndex}
        onTabChange={handleTabChange}>
        <TabPanel header={t('evaluation.tab-evaluation')}>
          <NotRatedReservationList />
        </TabPanel>
        <TabPanel disabled header={t('evaluation.tab-survey')} />
      </TabView>
    </div>
  )
}
